import { NgModule } from '@angular/core';
import { MsBreadcrumbsComponent } from './ms-breadcrumbs.component';
import { SharedLibsModule } from 'app/shared/shared-libs.module';

@NgModule({
	declarations: [MsBreadcrumbsComponent],
	imports: [SharedLibsModule],
	exports: [MsBreadcrumbsComponent],
	providers: [],
})
export class MsBreadcrumbsModule {}
